export default {
  computed: {
    $isAuth() {
      return this.$auth.check();
    },
  },

  watch: {
    $isAuth: {
      immediate: true,
      deep: true,
      handler(auth) {
        if (auth) {
          this.$prefetch();
        }
      },
    },
  },
};
